export default {
  name: 'customer_address_box',
  component_path: 'modules/procedures/blocks/BlockInputText'
}